import { ApolloClient, gql, useLazyQuery } from "@apollo/client";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Tooltip
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ErrorMessage } from "components/error";
import * as React from "react";
import {
  UserPermissionsQuery,
  UserPermissionsQueryVariables
} from "./schema/UserPermissionsQuery";

const useStyles = makeStyles(() => ({
  listHeader: {
    background: "aliceblue"
  }
}));

export default function UserPermissions({
  userName,
  client
}: {
  userName: string;
  client: ApolloClient<any>;
}) {
  const classes = useStyles();
  const [loadPermissions, { data: userPermissions, loading, error }] =
    useLazyQuery<UserPermissionsQuery, UserPermissionsQueryVariables>(
      gql`
        query UserPermissionsQuery($userName: String!) {
          accessManagement {
            user(name: $userName) {
              firstName
              lastName
              permissions
            }
          }
        }
      `,
      { variables: { userName }, client }
    );
  const [isPermissionsDialogOpen, setIsPermissionDialogOpen] =
    React.useState(false);
  const user = userPermissions?.accessManagement.user;
  return (
    <>
      <Tooltip title="View user permissions">
        <IconButton
          data-testid="show-user-permissions"
          onClick={() => {
            setIsPermissionDialogOpen(true);
            loadPermissions();
          }}
          size="large"
        >
          <LockOpenIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={isPermissionsDialogOpen}
        onClose={() => setIsPermissionDialogOpen(false)}
        BackdropProps={{
          style: {
            backgroundColor: "rgb(0,0,0,0.2)"
          }
        }}
        PaperProps={{
          style: {
            boxShadow: "none"
          }
        }}
      >
        <DialogContent>
          {loading && <CircularProgress />}
          {error && <ErrorMessage message={error.message} />}
          {user ? (
            <List
              dense
              subheader={
                <ListSubheader className={classes.listHeader}>
                  {user.firstName} {user.lastName}'s permissions
                </ListSubheader>
              }
            >
              {user.permissions.map((permission: string) => (
                <ListItem key={permission}>
                  <ListItemIcon>
                    <LockOpenIcon />
                  </ListItemIcon>
                  <ListItemText primary={permission} />
                </ListItem>
              ))}
            </List>
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
